<div class="hero-banner" [ngClass]="isFullBanner ? 'fullBanner' : 'halfBanner'">
  <img [src]="imgPath" alt="" />
  <div class="hero-overlay"></div>
  <div
    class="header"
    [ngClass]="{ fixed: isScrolled, transparent: !isScrolled }"
  >
    <div class="logo-container">
      <div class="logo">
        <a routerLink="/home" routerLinkActive="active">
          <h1>bourne bespoke</h1>
          <div class="tag">
            <i class="fa-solid fa-circle"></i>
            <h2>creative home enhancement</h2>
            <i class="fa-solid fa-circle"></i>
          </div>
        </a>
      </div>
    </div>

    <div class="navigation">
      <i class="fa-solid fa-bars" (click)="toggleNav()"></i>
    </div>
  </div>
  <div class="overlay-text">
    <!-- <h1 class="hero-text">excellence in every detail</h1> -->
    <h1 class="hero-text">{{ title }}</h1>
  </div>
</div>

<div class="side-nav" [ngClass]="{ open: navOpen }">
  <i class="fa-solid fa-times close-btn" (click)="toggleNav()"></i>
  <ul>
    <li>
      <a routerLink="/home" routerLinkActive="active" (click)="toggleNav()"
        >Home</a
      >
    </li>
    <li>
      <a routerLink="/about" routerLinkActive="active" (click)="toggleNav()"
        >About</a
      >
    </li>
    <li>
      <a routerLink="/creations" routerLinkActive="active" (click)="toggleNav()"
        >Creations</a
      >
    </li>
    <li>
      <a
        routerLink="/contact-us"
        routerLinkActive="active"
        (click)="toggleNav()"
        >Contact Us</a
      >
    </li>
  </ul>
</div>

<div
  class="page-overlay"
  [ngClass]="{ show: navOpen }"
  (click)="toggleNav()"
></div>
